import type { RouteRecordRaw } from 'vue-router';
import WelcomePage from '@menu/Pages/WelcomePage.vue';
import HomePage from '@menu/Pages/HomePage.vue';
import AboutPage from '@menu/Pages/AboutPage.vue';
import FormPage from '@menu/Pages/FormPage.vue';
import OrderPage from '@menu/Pages/OrderPage.vue';
import OrderPayPage from '@menu/Pages/OrderPayPage.vue';
import MenuPage from '@menu/Pages/MenuPage.vue';
import PlainMenuPage from '@menu/Pages/PlainMenuPage.vue';
import FavoritesPage from '@menu/Pages/FavoritesPage.vue';
import CartPage from '@menu/Pages/CartPage.vue';
import getSharedData from '@menu/Utils/getSharedData';
import { getPreferredLanguage } from '@menu/Utils/preferredLanguage';
import getRestaurant from '@menu/Utils/getRestaurant';

export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'root',
    redirect: () => ({
      name: 'welcome',
      params: { languageCode: getPreferredLanguage() },
    }),
  },
  {
    path: '/:languageCode',
    beforeEnter: [
      (to) => {
        if (
          !getRestaurant().languages.includes(to.params.languageCode as string)
        ) {
          return { name: 'root' };
        }
      },
    ],
    children: [
      {
        path: '',
        name: 'welcome',
        component: WelcomePage,
        beforeEnter: [
          (to) => {
            if (!getRestaurant().isWelcomePageEnabled) {
              return {
                name: 'home',
                params: {
                  languageCode: to.params.languageCode,
                },
              };
            }
          },
        ],
      },
      {
        path: 'home',
        name: 'home',
        component: HomePage,
        beforeEnter: [
          (to) => {
            if (getRestaurant().isHomePageEnabled) {
              return;
            }

            if (getRestaurant().menus.length === 0) {
              return;
            }

            return {
              name: 'menu',
              params: {
                languageCode: to.params.languageCode,
                menuSlug: getRestaurant().menus[0].slug,
              },
            };
          },
        ],
      },
      { path: 'about', name: 'about', component: AboutPage },
      {
        path: 'form',
        name: 'form',
        component: FormPage,
        beforeEnter: [
          (to) => {
            if (getRestaurant().forms.length === 0) {
              return {
                name: 'home',
                params: {
                  languageCode: to.params.languageCode,
                },
              };
            }
          },
        ],
      },
      {
        path: 'order/:orderUuid',
        name: 'order',
        component: OrderPage,
      },
      {
        path: 'order/:orderUuid/pay',
        name: 'orderPay',
        component: OrderPayPage,
      },
      {
        path: 'menu/:menuSlug',
        beforeEnter: [
          (to) => {
            if (
              !getRestaurant().menus.some(
                (menu) => menu.slug === to.params.menuSlug,
              )
            ) {
              return {
                name: 'home',
                params: {
                  languageCode: to.params.languageCode,
                },
              };
            }
          },
        ],
        children: [
          { path: '', name: 'menu', component: MenuPage },
          { path: 'plain', name: 'plainMenu', component: PlainMenuPage },
          {
            path: 'favorites',
            name: 'favorites',
            component: FavoritesPage,
          },
          {
            path: 'cart',
            name: 'cart',
            component: CartPage,
            beforeEnter: [
              (to) => {
                if (!getSharedData().isOrderMode) {
                  return {
                    name: 'menu',
                    params: {
                      languageCode: to.params.languageCode,
                      menuSlug: to.params.menuSlug,
                    },
                  };
                }
              },
            ],
          },
          {
            path: ':pathMatch(.*)*',
            redirect: (to) => {
              return {
                name: 'menu',
                params: {
                  languageCode: to.params.languageCode,
                  menuSlug: to.params.menuSlug,
                },
              };
            },
          },
        ],
      },
    ],
  },
  { path: '/:pathMatch(.*)*', redirect: '/' },
];
